import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { stripTokens } from '../interpolate';
const ASPECT_PADDING = {
    wide: '56.25%', // 16:9
    square: '100%', // 1:1
    tall: '125%', // 4:5
};
export function ImageBlock({ block }) {
    const padBottom = ASPECT_PADDING[block.aspect] ?? '56.25%';
    const alt = stripTokens(block.alt ?? '');
    return (_jsx("div", { className: "relative w-full overflow-hidden rounded-2xl bg-slate-100", style: { paddingBottom: padBottom }, children: block.media_url ? (_jsx("img", { src: block.media_url, alt: alt, className: "absolute inset-0 h-full w-full object-cover", loading: "lazy" })) : (_jsx("div", { className: "absolute inset-0 flex items-center justify-center text-slate-300", children: _jsxs("svg", { width: "32", height: "32", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", "aria-hidden": "true", children: [_jsx("rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }), _jsx("circle", { cx: "8.5", cy: "8.5", r: "1.5" }), _jsx("polyline", { points: "21 15 16 10 5 21" })] }) })) }));
}
